// extracted by mini-css-extract-plugin
export default {"person":"GuestInfo_person_p7LUs","cFix":"GuestInfo_cFix_hXFpp","cFixExpanded":"GuestInfo_cFixExpanded_xe0K1"};